import { render, staticRenderFns } from "./threeText.vue?vue&type=template&id=358ca4c8&scoped=true"
import script from "./threeText.vue?vue&type=script&lang=js"
export * from "./threeText.vue?vue&type=script&lang=js"
import style0 from "./threeText.vue?vue&type=style&index=0&id=358ca4c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ca4c8",
  null
  
)

export default component.exports